import React, {useEffect,useState} from "react";
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { connect } from 'react-redux'
import { setAuthLoading, changePass, changePassOld } from "../../actions/authActions";
import { Redirect } from "react-router-dom"
import Spinner from 'components/common/Spinner';
// reactstrap components
import {
  Button, 
  Card, 
  CardTitle, 
  CardHeader, 
  CardBody, 
  CardFooter, 
  Form, 
  Input, 
  InputGroupAddon, 
  InputGroupText, 
  InputGroup ,  
  Container, 
  Col, 
  Row, 
  Modal
} from "reactstrap";

import { loginUser, refreshUser } from '../../actions/authActions'


import logo from "assets/img/aotmit_logo_BG.png";
// import { isTypeParameter } from "babel-types";

const LoginPage = ({isAuthenticated, loginUser, loading, setAuthLoading, refreshUser, error, changePass, changePassOld, res}) => {
  const [searchParams] = useSearchParams();
  const isTesting = searchParams.get("passwordtest") === "test";
  const [formData, setFormData] = useState({ email: "", password: "" });

  console.log("Login")

  useEffect(() => {
    refreshUser()
    document.body.classList.toggle("login-page");
    return function cleanup() {
      document.body.classList.toggle("login-page");
    };
    // eslint-disable-next-line
  }, []);

  const handleFieldChange = (e) => {
    const fieldValue = e.target.value;
    const fieldIndex = e.target.id

    setFormData((prevState) => {
        const prevLoginValues = { ...prevState };
        prevLoginValues[fieldIndex] = fieldValue;
        return prevLoginValues;
    });
}

const navigate = useNavigate();
const handleSubmit = (e) => {
  loginUser(formData)
}

const [modalMini, setModalMini] = useState(false);
const toggleModalMini = () => {
  setModalMini(!modalMini);
};
const [resetStep, setResetStep] = useState(0);
const [modalReset, setModalReset] = useState(false);
const toggleModalReset = () => {
  setModalReset(!modalReset);
};
useEffect(() => {
  if(loading) setResetStep(1)
  else setResetStep(2)
  // eslint-disable-next-line
}, [loading]);

useEffect(() => {
  if(error !== null) toggleModalMini()
  // eslint-disable-next-line
}, [error]);
useEffect(() => {
  if(isAuthenticated){
    navigate('/admin/main_page')
  }
  // eslint-disable-next-line
}, [isAuthenticated]);

const errorMsg = (err) =>{
  let msg = []
  let keys = err!==null?Object.keys(err):[]
  if (keys.includes('password')) msg.push('Pole hasło nie może być puste.')
  if (keys.includes('email')) msg.push('Pole e-mail nie może być puste.')
  if (keys.includes('non_field_errors')) msg.push(err.non_field_errors)
  return msg.length===0?'Wystąpił błąd przy próbie logowania':msg.join('\n')
}
// if (isAuthenticated) {
//   const { from } = location.state || { from: "/" }
//   return <Redirect to={from} />
// }
const loginUserEnter = (event) =>{
  if(event.key === "Enter") {
    loginUser(formData)
     }}

  return (
    <div className="login-page">
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" md="12">
            <ul className="breadcrumb-links" style={{marginBottom: '80px'}}>
              <li><a href="/">Strona główna</a></li>
              <li>Logowanie</li>
            </ul>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" lg="4" md="6">
            <Form className="form" >
              <Card className="card-login">
                <CardHeader >
                  <div className={"logo-container"}>
                    <img
                      src={logo}
                      className="login-img"
                      alt="AOTMiT logo"
                    />
                  </div>

                  <CardTitle className="text-center" tag="h3">
                    Zaloguj się
                  </CardTitle>
                </CardHeader>

                <CardBody>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="nc-icon nc-single-02" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <label htmlFor="email" className="sr-only">e-mail</label>
                    <Input 
                      id={`email`}
                      placeholder="e-mail" 
                      type="text"
                      // autoComplete="off"
                      value={formData['email']}
                      onChange={(e)=>handleFieldChange(e)}
                      onKeyUp={loginUserEnter}
                      />
                  </InputGroup>
                  <InputGroup className='mb-0'>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="nc-icon nc-key-25" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <label htmlFor="password" className="sr-only">hasło</label>
                    <Input
                      id={'password'}
                      placeholder="hasło"
                      type="password"
                      autoComplete="off"
                      value={formData.password}
                      onChange={(e)=>{handleFieldChange(e)}}
                      onKeyUp={loginUserEnter}
                    />
                  </InputGroup>

                </CardBody>
                <CardFooter>
                  <Button
                    block
                    className="btn-round btn-outline-aotmit mb-3 btn-shadow"
                    color="aotmit"
                    type="button"
                    onClick={(e)=>{handleSubmit(e)}}
                    // href="#pablo"
                  >Zaloguj</Button>
                  <div className='login'>
                    <p>
                      Nie pamiętasz hasła?{' '}
                      <Link
                        onClick={(e) => {e.preventDefault(); setResetStep(0); setModalReset(true); }}
                      >
                        Resetuj hasło
                      </Link>
                      .
                    </p>
                  </div>
                  <div className='login'>
                    <p className='mb-0'>
                      Nie masz konta?{' '}
                      <Link
                        to='/auth/register'
                        // onClick={(e) => e.preventDefault()}
                      >
                        Zarejestruj się
                      </Link>
                      .
                    </p>
                  </div>
                  {/* <div className="login">
                    <p>
                      <Link to="/auth/login"
                        className={'ml-4'}
                      // onClick={(e) => e.preventDefault()}
                      >
                        Nie pamiętam hasła
                      </Link>
                    </p>
                  </div> */}
                </CardFooter>
              </Card>
            </Form>
          </Col>
        </Row>
      </Container>
      <Modal className="modal-sm" modalClassName="modal-primary" isOpen={modalMini} toggle={toggleModalMini}>
        {<>
          <div className="modal-header justify-content-center">
            <div className="modal-profile ml-auto mr-auto">
              <i className="nc-icon nc-simple-remove" />
            </div>
          </div>
          <div className="modal-body text-center">
            <p> {errorMsg(error)}</p>
          </div>
        <div className="modal-footer">
            <Button color="link" data-dismiss="modal" type="button" onClick={()=>toggleModalMini()} >
              Rozumiem
            </Button>
        </div></>}
      </Modal>

      <Modal className="modal-md" modalClassName="modal-primary" isOpen={modalReset} toggle={toggleModalReset}>
        <div className="modal-header justify-content-center">
          <div className="modal-profile ml-auto mr-auto">
            <i className="nc-icon nc-touch-id" />
          </div>
        </div>
        {resetStep==0 && <>
          <div className="modal-body text-center">
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="nc-icon nc-single-02" />
                </InputGroupText>
              </InputGroupAddon>
              <Input 
                id={`email`}
                placeholder="e-mail" 
                type="text"
                // autoComplete="off"
                value={formData['email']}
                onChange={(e)=>handleFieldChange(e)}
                onKeyUp={()=>{}}
                />
            </InputGroup>
          </div>
          <div className="modal-footer">
            <div className="left-side">
              <Button className="btn-link" color="default" type="button" onClick={() => { changePassOld({'email':formData['email']}); } } >
                Resetuj hasło
              </Button>
              {isTesting && <Button className="btn-link" color="default" type="button" onClick={() => { changePass({'email':formData['email']}); } } >
                Resetuj hasło (nowe)
              </Button>}
            </div>
            <div className="divider" />
            <div className="right-side">
              <Button className="btn-link" color="danger" type="button" onClick={()=> { toggleModalReset(); }} >
                Anuluj
              </Button>
            </div>
          </div>
        </>}
        {resetStep==1 && <>
          <div className="modal-body text-center">
           <h5 className="modal-title text-center" id="exampleModalLabel" >
              <Spinner /><br/> Przetwarzanie, proszę czekać...            
            </h5>
          </div>
        </>}
        {resetStep==2 && <>
          <div className="modal-body text-center">
            {res}
          </div>
          <div className="modal-footer">
            {res==="Nie ma takiego użytkownika."?<>
              <div className="left-side">
                <Button className="btn-link" color="warning" type="button" onClick={() => { setFormData({ email: "", password: "" }); setResetStep(0) } } >
                  Spróbuj ponownie
                </Button>
              </div>
              <div className="divider" />
              <div className="right-side">
                <Button className="btn-link" color="default" type="button" onClick={()=> { toggleModalReset(); }} >
                  Rozumiem
                </Button>
              </div>
            </>:
              <Button className="btn-link" color="default" type="button" onClick={()=> { toggleModalReset(); }} >
                Rozumiem
              </Button>
            }
            
          </div>
        </>}
      </Modal>
    </div>
  );
}

// Login.propTypes = {
//   loginUser: PropTypes.func.isRequired,
//   isAuthenticated: PropTypes.bool,
// }

const mapStateToProps = state => ({
  isAuthenticated: state.authReducer.isAuthenticated,
  loading: state.authReducer.auth_loading,
  error: state.authReducer.error,
  res: state.authReducer.res,
})

export default connect(mapStateToProps, { loginUser, refreshUser, setAuthLoading, changePass, changePassOld })(LoginPage)
